module.exports = __webpack_public_path__ + "src/img/zalando/iso-phone.38fe7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/zalando/iso-phone.jpg
// module id = 270
// module chunks = 0